module.exports = __webpack_public_path__ + "static/media/session.5b9e458a.png";